import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=f09281c4&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=f09281c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09281c4",
  null
  
)

export default component.exports